import React from 'react';

import {listPageClassName} from 'shared/ui/ListPage/ListPage';

import {MainLayout} from 'widgets/layout';

import {HttpMonitors} from 'features/http';

const HttpMonitorsPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <HttpMonitors />
        </MainLayout>
    );
};

export default HttpMonitorsPage;
